module.exports = __webpack_public_path__ + "img/sj_qihuo.eaf1760a.jpg";